import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imTaskForm', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/periodic_tasks/task_form/task_form.html'),
        controller: 'TaskFormController',
        controllerAs: 'TaskFormCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/task_form/task_form.component.ts